module.exports = __webpack_public_path__ + "static/media/connection_service_business_unit_4.9fced04c.png";